const PicsApi = {
    getAlert: (alertId) => PicsApi._fetch('alertbyid', { id: alertId }),

    getAlerts: () => PicsApi._fetch('alerts', { include_access_alerts: 'true' }),

    getAlertsByRoute: (routeId) => PicsApi._fetch('alertsbyroute', { route: routeId }),

    getAlertsByStop: (stopId) => PicsApi._fetch('alertsbystop', { stop: stopId }),

    getPredictionsByRoute: (routeId) => PicsApi._fetch('predictionsbyroutes', { routes: routeId }),

    getPredictionsByStop: (stopId) => PicsApi._fetch('predictionsbystop', { stop: stopId, display_child_stops: '1' }),

    getRoutes: () => PicsApi._fetch('routes', { include_route_short_name: '1' }),

    getRoutesByStop: (stopId) => PicsApi._fetch('routesbystop', { stop: stopId, include_route_short_name: '1' }),

    getScheduleByRoute: (routeId, range, start, maxTrips) => {
        if (maxTrips) return PicsApi._fetch('schedulebyroutes', { routes: routeId, max_time: range, datetime: start, max_trips: maxTrips });
        if (start) return PicsApi._fetch('schedulebyroutes', { routes: routeId, max_time: range, datetime: start });
        return PicsApi._fetch('schedulebyroutes', { routes: routeId, max_time: range });
    },

    getScheduleByStop: (stopId, range, start, maxTrips) => {
        if (maxTrips) return PicsApi._fetch('schedulebystop', { stop: stopId, max_time: range, datetime: start, max_trips: maxTrips, display_child_stops: '1' });
        if (start) return PicsApi._fetch('schedulebystop', { stop: stopId, max_time: range, datetime: start, display_child_stops: '1' });
        return PicsApi._fetch('schedulebystop', { stop: stopId, max_time: range, display_child_stops: '1' });
    },

    getStopsByLocation: (lat, lon, max_distance = 1) => PicsApi._fetch('stopsbylocation', { lat, lon, max_distance }),

    getStopsByRoute: (routeId, from, to) => PicsApi._fetch('stopsbyroute', { route: routeId, from_datetime: from, to_datetime: to }),

    _fetch: (resource, params) => {
        let qs = new URLSearchParams();

        qs.append('format', 'json');
        qs.append('api_key', picsApiKey);
        
        if (params) {
            for (let param in params) {
                if (Object.prototype.hasOwnProperty.call(params, param) && params[param] !== null) {
                    qs.append(param, params[param]);
                }
            }
        }

        return fetch(picsApiUrl + '/' + resource + '?' + qs.toString());
    }
};

export default PicsApi;